<template>
  <div class="footer">
    <div class="footer-bottom">
      <div class="muted">© {{ new Date().getFullYear() }} EasySaúde. Contato para parcerias e demonstrações.</div>
      <div class="links">
        <a href="https://sidsolucoes.com" target="_blank" rel="noopener noreferrer">SiD Soluções</a>
        <span class="sep" aria-hidden="true">•</span>
        <span>Sistemas Digitais</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSection',
  props: {
    appLoginUrl: { type: String, required: true }
  }
}
</script>

<style scoped>
.footer {
  padding: 26px 0 10px;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 14px;
  color: var(--easy-muted);
  font-weight: 700;
  font-size: 13px;
}

.links a {
  color: var(--easy-muted);
  text-decoration: none;
  border-bottom: 1px dashed rgba(100, 116, 139, 0.35);
}

.links a:hover {
  color: var(--easy-dark);
  border-bottom-color: rgba(77, 186, 135, 0.7);
}

.sep {
  margin: 0 8px;
}

@media (max-width: 860px) {
  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
